import './App.css';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import PublicRoutes from './Components/Routes/publicRoutes';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <BrowserRouter>
        <PublicRoutes />
      </BrowserRouter>

      {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/916304960489"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}

export default App;
